import styled from "styled-components";
import media from "constants/media";

export const ImagesStyled = styled.div`
    position: relative;
    z-index: 2;

    margin-bottom: 36px;

    ${media.mdUp`
        margin-bottom: 109px;
    `}
`;

export const Grid = styled.div`
    position: relative;

    width: 100%;
    max-width: 580px;
    margin: 0 auto;

    ${media.mdUp`
        max-width: 780px;
    `}
`;

export const Image = styled.div`
    position: relative;
`;

export const Top = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: center;
    margin-bottom: 10px;
    overflow: hidden;

    ${media.mdUp`
        margin-bottom: 20px;
    `}

    ${Image} {
        &:first-child {
            width: 190px;
            height: 150px;

            margin-right: 5px;

            ${media.mdUp`
                width: calc(62.5% - 10px);
                height: 220px;
    
                margin-right: 10px;
            `}
        }

        &:last-child {
            width: 175px;
            height: 140px;

            margin-left: 5px;

            ${media.mdUp`
                width: calc(37.5% - 10px);
                height: 310px;
    
                margin-left: 10px;
            `}
        }
    }
`;

export const Bottom = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: center;

    ${Image} {
        &:first-child {
            width: 150px;
            height: 110px;

            ${media.mdUp`
                width: calc(50% - 10px);
                height: 280px;
                margin-right: 10px;
            `}
        }

        &:nth-child(2) {
            width: 130px;
            height: 140px;
            margin: 0 10px;

            ${media.mdUp`
                width: auto;
                height: auto;
                margin: 0;
            `}
        }

        &:last-child {
            width: 134px;
            height: 130px;

            ${media.mdUp`
                width: calc(50% - 10px);
                height: 370px;
                margin-left: 10px;
            `}
        }
    }
`;

export const Left = styled.div`
    position: absolute;
    top: 0;
    left: -20px;

    display: flex;
    flex-direction: column;
    align-items: flex-end;

    margin-top: -300px;

    transform: translateX(-100%);

    /* stylelint-disable-next-line */
    ${Image} {
        &:first-child {
            width: 420px;
            height: 280px;

            margin: 0 -40px 20px 0;
        }

        &:nth-child(2) {
            width: 355px;
            height: 280px;

            margin: 0 0 20px;
        }

        &:last-child {
            width: 280px;
            height: 300px;
        }
    }
`;

export const Right = styled.div`
    position: absolute;
    top: 0;
    right: -20px;

    display: flex;
    flex-direction: column;

    margin-top: -300px;

    transform: translateX(100%);

    /* stylelint-disable-next-line */
    ${Image} {
        &:first-child {
            width: 355px;
            height: 280px;

            margin: 0 0 20px -40px;
        }

        &:last-child {
            width: 290px;
            height: 630px;
        }
    }
`;

export const Text = styled.p`
    margin-top: 24px;

    font-size: 14px;
    line-height: 20px;

    ${media.mdUp`
        width: calc(50% - 10px);
        margin-top: -70px;
        
        font-size: 15px;
        line-height: 25px;
    `}
`;
